import { useState } from 'react';
import classnames from 'classnames';
import { Image, getFallbackImageSrc } from '@/components/Image';
import './index.scss';

export const Avatar = ({
  image,
  src,
  alt,
  nameInitials,
  className,
  active,
  size = 50,
  errorRender,
}) => {
  const [showImg, setShow] = useState(true);
  const imageSource = getFallbackImageSrc(image, 'thumbnail') ? image : src;
  const hasImage = !!getFallbackImageSrc(imageSource, 'thumbnail');
  const styles = {
    minWidth: size,
    minHeight: size,
    width: size,
    height: size,
  };

  if (!showImg && errorRender) {
    return errorRender();
  }

  return (
    <div
      className={classnames(
        'avatar__wrap',
        active && 'avatar__active',
        className,
      )}
      style={styles}
    >
      <div className="avatar">
        {hasImage && showImg ? (
          <Image
            image={imageSource}
            preset="avatar"
            sizes={`${size}px`}
            className="avatar__image"
            alt={alt || 'avatar'}
            onError={() => setShow(false)}
          />
        ) : (
          <div className="avatar__initials">
            <span style={{ fontSize: `${(22 * size) / 60}px` }}>
              {nameInitials || 'S'}
            </span>
          </div>
        )}
      </div>
    </div>
  );
};
